export default __webpack_public_path__ + "static/media/delete.dcfa6104.svg";